export default class DiscountRuleHistory {
  rule: string;

  enabled: boolean;

  value: string;

  constructor(obj: any = {}) {
    this.rule = obj.rule || '';
    this.enabled = obj.enabled || '';
    this.value = obj.value || '';
  }

  public static of(obj: any = {}): DiscountRuleHistory {
    return new DiscountRuleHistory(obj);
  }

  public static ofList(obj: any[]): DiscountRuleHistory[] {
    return obj.map(this.of)
  }

  get enabledText() {
    return this.enabled ? 'Sim' : 'Não'
  }
}
